export default __webpack_public_path__ + "static/media/Stand alone main cover.f46b600a.jpg";